import React from 'react';
import Header from '../widgets/Header';
import SideBar from '../widgets/SideBar';
import Footer from '../widgets/Footer';

const MainLayout = ({ children }) => {
    return (
        <>
            <Header />
            <SideBar />
            <main id="main" className="main">
                {children}
            </main>
            <Footer />
        </>
    );
};

export default MainLayout;
